<template>
  <div class="content">
    <img src="https://ysh-cdn.kaidicloud.com/test/chamber/gx_chamber-intro_1_new.png?5" alt="" />
    <img src="https://ysh-cdn.kaidicloud.com/test/chamber/gx_chamber-intro_2_new.png?5" alt="" />
    <img src="https://ysh-cdn.kaidicloud.com/test/chamber/gx_chamber-intro_3_new.png?5" alt="" />
    <img src="https://ysh-cdn.kaidicloud.com/test/chamber/gx_chamber-intro_4_new.png?5" alt="" />
    <div class="bottom-wrap">
      <img src="https://ysh-cdn.kaidicloud.com/test/chamber/chamber-intro-btn_new.png?4" alt="" class="btn" @click="onSettle">
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
import { getWxLink } from '@/api/data'

Vue.use(Toast)
export default {
  data() {
    return {
      url: '',
    }
  },
  created() {},
  async mounted() {
    let channel = encodeURIComponent(this.$route.query.channel || '')

    const res = await getWxLink('pages/apply/index', `settledSource=7&channel=${channel}`)
    if (res.data.state !== 1) return Toast('短链生成失败')
    this.url = res.data.data.url
  },
  methods: {
    onSettle() {
      if (!this.url) return Toast('短链生成中，请稍后...')
      window.location.href = this.url
    }
  },
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.content {
  img {
    width: 100%;
    display: block;
  }
}
.bottom-wrap {
  width: 100%;
  height: 14vh;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;

  .btn {
    width: 50%;
  }
}
</style>
